import React from 'react';
import classNames from 'classnames';
import CustomButton from 'components/customButton';
import useDeleteAd from './hooks/useDeleteAd';
interface DeleteFormProps {
  app: 'farm' | 'wholesaler';
  guid: string;
  type: 'wanted-post' | 'post';
  delete_reason: 'unsuccessful' | 'successful' | 'canceled' | 'unknown';

  setIsopen: (isOpen: boolean) => void;
  refetch: () => void;
}
const DeleteForm = ({
  app,
  guid,
  type,
  delete_reason,
  setIsopen,
  refetch,
}: DeleteFormProps) => {
  const {isLoading, mutate} = useDeleteAd({
    refetch,
    action: () => setIsopen(false),
  });
  return (
    <div className="flex w-full flex-col gap-4 relative">
      <div className="flex flex-col w-full justify-center items-center gap-4">
        <div
          className={classNames(' bg-white p-4 rounded-full', {
            'absolute top-[-60px]  border-2 border-primary ':
              app === 'wholesaler' ? true : false,
          })}
        >
          <span className="icon-error text-error text-[50px]" />
        </div>
        <h4
          className={classNames('text-gray-5 font-medium text-18px', {
            'mt-16 mb-8': app === 'wholesaler' ? true : false,
          })}
        >
          آیا اطمینان به حذف آگهی دارید؟
        </h4>
      </div>

      <div className="flex w-full items-center  gap-4">
        <CustomButton
          className="!bg-white  !text-red-1 !w-[50%]"
          type="button"
          title="انصراف"
          onClick={() => setIsopen(false)}
        />
        <CustomButton
          isLoading={isLoading}
          className="!bg-error  !text-white !w-[50%]"
          type="button"
          title="بله"
          onClick={() =>
            mutate({
              guid: guid,
              delete_reason: delete_reason,
              type: type,
            })
          }
        />
      </div>
    </div>
  );
};

export default DeleteForm;
